import {
  Anchor,
  Container,
  List,
  Space,
  Text,
  Title,
} from '@mantine/core';
import LabelIcon from '@mui/icons-material/Label';
import {
  createFileRoute,
} from '@tanstack/react-router';

import {
  NonBreakingCharEnum,
} from '@specia-accountant/shared';

export const Route = createFileRoute('/_app/_landing/privacy')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <Container>
        <Space
          h="xl"
        />
        <Text
          variant="gradient"
        >
          <Title
            order={ 1 }
          >
            Specia Privacy Policy
          </Title>
        </Text>
        <Text
          c="dimmed"
        >
          <Space
            h="md"
          />
          <Title
            order={ 3 }
          >
            Specia is an initiative of Spectar Group Pty Ltd
          </Title>
          <Space
            h="md"
          />
          Spectar Group Pty Ltd is committed to providing quality services to
          you and this privacy policy outlines our ongoing obligations to you in
          respect of how we manage your Personal Information. We have adopted
          the Australian Privacy Principles (APPs) contained in the Privacy Act
          1988 (Cth) (the Privacy Act). The APPs govern the way in which we
          collect, use, disclose, store, secure and dispose of your Personal
          Information. A copy of the Australian Privacy Principles may be
          obtained from the website of The Office of the Australian Information
          Commissioner at www.aoic.gov.au
          <Space
            h="md"
          />
          <Title
            order={ 3 }
          >
            What is Personal Information and why do we collect it?
          </Title>
          <Space
            h="md"
          />
          Personal Information is information or an opinion that identifies an
          individual. Examples of Personal Information we collect include names,
          addresses, email addresses, phone, and facsimile numbers. This
          Personal Information is obtained in many ways including interviews,
          correspondence, by telephone and facsimile, by email, via our websites
          { NonBreakingCharEnum.space }
          <Anchor
            href="https://spectargroup.com"
            target="_blank"
            underline="hover"
          >
            spectargroup.com
          </Anchor>
          ,
          <Anchor
            href="https://specia.ai"
            target="_blank"
            underline="hover"
          >
            specia.ai
          </Anchor>
          , from your website, from media and publications,
          from other publicly available sources, from cookies and from third
          parties. We do not guarantee website links or policy of authorised
          third parties. We collect your Personal Information for the primary
          purpose of providing our services to you, providing information to our
          clients and marketing. We may also use your Personal Information for
          secondary purposes closely related to the primary purpose, in
          circumstances where you would reasonably expect such use or
          disclosure. You may unsubscribe from our mailing/marketing lists at
          any time by contacting us in writing. When we collect Personal
          Information we will, where appropriate and where possible, explain to
          you why we are collecting the information and how we plan to use it.
          <Space
            h="md"
          />
          <Title
            order={ 3 }
          >
            Sensitive Information
          </Title>
          <Space
            h="md"
          />
          Sensitive information is defined in the Privacy Act to include
          information or opinion about such things as an individual’s racial or
          ethnic origin, political opinions, membership of a political
          association, religious or philosophical beliefs, membership of a trade
          union or other professional body, criminal record or health
          information. Sensitive information will be used by us only:
          <Space
            h="md"
          />
          <List
            icon={ (
              <LabelIcon
                sx={ {
                  fontSize: 12,
                } }
              />
            ) }
            spacing="sm"
            withPadding
          >
            <List.Item>
              For the primary purpose for which it was obtained
            </List.Item>
            <List.Item>
              For a secondary purpose that is directly related to the primary
              purpose
            </List.Item>
            <List.Item>
              With your consent; or where required or authorised by law.
            </List.Item>
          </List>
          <Space
            h="lg"
          />
          <Space
            h="md"
          />
          <Title
            order={ 3 }
          >
            Third Parties
          </Title>
          <Space
            h="md"
          />
          Where reasonable and practicable to do so, we will collect your
          Personal Information only from you. However, in some circumstances we
          may be provided with information by third parties. In such a case we
          will take reasonable steps to ensure that you are made aware of the
          information provided to us by the third party.
          <Space
            h="md"
          />
          <Title
            order={ 3 }
          >
            Disclosure of Personal Information
          </Title>
          <Space
            h="md"
          />
          Your Personal Information may be disclosed in a number of
          circumstances including the following:
          <Space
            h="md"
          />
          <List
            icon={ (
              <LabelIcon
                sx={ {
                  fontSize: 12,
                } }
              />
            ) }
            spacing="sm"
            withPadding
          >
            <List.Item>
              Third parties where you consent to the use or disclosure; and
            </List.Item>
            <List.Item>
              Where required or authorised by law.
            </List.Item>
          </List>
          <Space
            h="lg"
          />
          <Space
            h="md"
          />
          <Title
            order={ 3 }
          >
            Security of Personal Information
          </Title>
          <Space
            h="md"
          />
          Your Personal Information is stored in a manner that reasonably
          protects it from misuse and loss and from unauthorized access,
          modification, or disclosure. When your Personal Information is no
          longer needed for the purpose for which it was obtained, we will take
          reasonable steps to destroy or permanently de-identify your Personal
          Information. However, most of the Personal Information is or will be
          stored in client files which will be kept by us for a minimum of 7
          years.
          <Space
            h="md"
          />
          <Title
            order={ 3 }
          >
            Access to your Personal Information
          </Title>
          <Space
            h="md"
          />
          You may access the Personal Information we hold about you and to
          update and/or correct it, subject to certain exceptions. If you wish
          to access your Personal Information, please contact us in writing.
          Spectar Group Pty Ltd will not charge any fee for your access request
          but may charge an administrative fee for providing a copy of your
          Personal Information. In order to protect your Personal Information,
          we may require identification from you before releasing the requested
          information. Maintaining the Quality of your Personal Information It
          is an important to us that your Personal Information is up to date. We
          will take reasonable steps to make sure that your Personal Information
          is accurate, complete, and up to date. If you find that the
          information we have is not up to date or is inaccurate, please advise
          us as soon as practicable so we can update our records and ensure we
          can continue to provide quality services to you. Privacy Policy
          Updates This Policy may change from time to time and is available on
          our website.
          <Space
            h="md"
          />
          <Title
            order={ 3 }
          >
            Privacy Policy Complaints and Enquiries
          </Title>
          <Space
            h="md"
          />
          If you have any queries or complaints about our Privacy Policy, please
          contact us at:
          <Space
            h="sm"
          />
          Spectar Group Pty Ltd
          <br />
          313/530 Lt. Collins St.
          <br />
          Melbourne, VIC, 3000
          <br />
          <Anchor
            href="mailto:admin@spectargroup.com?subject=specia.ai"
            target="_blank"
            underline="hover"
          >
            admin@spectargroup.com
          </Anchor>
          <br />
          <Anchor
            href="https://spectargroup.com"
            target="_blank"
            underline="hover"
          >
            spectargroup.com
          </Anchor>
          <br />
          <Anchor
            href="tel:+61399097101"
            target="_blank"
            underline="hover"
          >
            03
            { NonBreakingCharEnum.narrowSpace }
            9909
            { NonBreakingCharEnum.narrowSpace }
            7101
          </Anchor>
          <br />
        </Text>
      </Container>
    </>
  );
}
